import React from "react";

import Grid from "@material-ui/core/Grid";

import {
  Input,
  SelectField,
  withNamespace,
} from "components/Form/FormikControls";

import {
  SaleStatusLabels,
  SaleType,
  SelectableSaleStatuses,
} from "constants/sale";

interface SaleStatusFormProps {
  namespace?: string;
}

export function SaleStatusForm(props: SaleStatusFormProps) {
  const { namespace: ns = "" } = props;

  const saleTypeOptions = Object.values(SaleType).map(value => ({
    value,
    label: value,
  }));

  const SaleStatusArchetypesOptions = SelectableSaleStatuses.map(value => ({
    value,
    label: SaleStatusLabels[value],
  }));

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Input name={withNamespace(ns, "name")} label="Name" required />
      </Grid>

      <Grid item xs={12}>
        <SelectField
          name={withNamespace(ns, "archetype")}
          label="Base"
          required
          options={SaleStatusArchetypesOptions}
          menuPortalTarget={document.body}
        />
      </Grid>

      <Grid item xs={12}>
        <SelectField
          name={withNamespace(ns, "saleType")}
          label="Sale Type"
          tooltip="Selecting a Sale Type will restrict this Status to only be available on Sales of that Type."
          options={saleTypeOptions}
          menuPortalTarget={document.body}
          isClearable
        />
      </Grid>
    </Grid>
  );
}
